import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../context/UserContext'

import LayoutHome from '../LayoutHome/LayoutHome'
import ChecklistFigure from '../ChecklistFigure/ChecklistFigure'
import FallbackLoader from '../FallbackLoader/FallbackLoader'

const LoginWall = (props) => {
  if (!Object.keys(props.component).length) return <></>

  const [load, setLoad] = useState(false)

  const UserState = useContext(UserContext)

  const component = { ...props.component[0] }
  component.figure = component.figure[0]
  component.listItems = component.listItems.map((listItem) => listItem.text)
  component.button = component.optionalButton.map((obj, index) => {
    obj.button.image = process.env.NEXT_PUBLIC_THEME !== 'sportwide' ? { svgId: `logo-${process.env.NEXT_PUBLIC_THEME}nl` } : null
    obj.button.icon = { id: 'icon-chevron-right' }
    obj.button.modifiers = [`Button--account ${index === 0 ? 'Button--accountLogin' : 'Button--accountRegister'}`]
    return obj.button
  })
  component.modifiers = ['ChecklistFigure--loginWall']

  useEffect(() => {
    if (UserState.userSession !== undefined && !load) {
      setLoad(true)
    }
  }, [UserState])

  if (!load) {
    return <FallbackLoader />
  }

  return <LayoutHome headerContent={<></>} mainContent={<>{component && <ChecklistFigure {...component} />}</>} />
}

LoginWall.defaultProps = {
  component: []
}

LoginWall.propTypes = {
  component: PropTypes.array
}

export default LoginWall
